import * as tslib_1 from "tslib";
import { FeatureFlag, } from '@models';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { BulkAddItemsModalComponent, TransactionChartModalComponent, } from '@pages/queues/modals';
import { ModalService, QueueDefinitionService, } from '@services';
import { encodeParams } from '@utils/encode.utils';
import cloneDeep from 'lodash-es/cloneDeep';
import { TriggerType } from 'main/models/trigger.model';
import { forkJoin, of, } from 'rxjs';
import { catchError } from 'rxjs/operators';
var HAS_TRIGGER_LIST = function () {
    return cloneDeep([{
            value: [{
                    property: 'triggerId',
                    method: 'eq',
                    value: null,
                }],
            label: 'No',
            translationKey: 'ToggleBoolean_No',
        }, {
            value: [{
                    property: 'triggerId',
                    method: 'ne',
                    value: null,
                }],
            label: 'Yes',
            translationKey: 'ToggleBoolean_Yes',
        }]);
};
var ɵ0 = HAS_TRIGGER_LIST;
var ɵ1 = urlStateHandler;
var QueuesPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(QueuesPageComponent, _super);
    function QueuesPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMonitoringEnabled = _this._appState.settings.isFeatureEnabled(FeatureFlag.Monitoring);
        _this.hasTriggerList = HAS_TRIGGER_LIST();
        _this.isCurrentFolderClassic$ = _this._appState.user.folder.isClassic$;
        _this._modalService = _this._injector.get(ModalService);
        _this._queueService = _this._injector.get(QueueDefinitionService);
        return _this;
    }
    QueuesPageComponent.prototype.getQueueTriggerParams = function (_a) {
        var id = _a.id, name = _a.name;
        return {
            type: TriggerType.Queue,
            queue: encodeParams({ id: id, name: name }),
        };
    };
    QueuesPageComponent.prototype.removeItems = function (items) {
        var _this = this;
        if (items === void 0) { items = this._grid.selectionManager.selected; }
        var hasItemsWithSchedule = !!items.find(function (i) { return !!i.triggerId; });
        this._modalService.onConfirm(null, function () {
            forkJoin(items.map(function (_a) {
                var id = _a.id;
                return _this._queueService
                    .delete(id)
                    .pipe(catchError(function () { return of(true); }));
            }))
                .subscribe(function () { return _this._refresh$.next(); });
        }, function () { }, hasItemsWithSchedule ?
            this._translate.instant('grid_action_delete_queues_with_schedule') :
            this._translate.instant('grid_action_delete_message'));
    };
    QueuesPageComponent.prototype.viewChart = function (entry) {
        var clone = !!entry ? cloneDeep(entry) : undefined;
        this._modalService.openModal(TransactionChartModalComponent, clone, { autoFocus: false, size: 'lg' });
    };
    QueuesPageComponent.prototype.onBulkAdd = function (entry) {
        if (!entry) {
            return;
        }
        this._modalService
            .openModal(BulkAddItemsModalComponent, cloneDeep(entry));
    };
    return QueuesPageComponent;
}(ODataGridComponent));
export { QueuesPageComponent };
export { ɵ0, ɵ1 };
